// GENERATED by scripts/stamp-build.js at build time (npm `prebuild`). Do not edit.
//
// The value committed to the repo is a PLACEHOLDER and says so in `source`. Every build
// overwrites this file, so a bundle whose source is `placeholder` was never stamped and a
// bundle whose source is `unresolved` was stamped where no commit could be determined.
export const buildInfo = {
  "sha": "02a661d37fe8118f1f58aa5be394891e19486089",
  "source": "cloudflare-pages",
  "builtAt": "2026-11-04T21:23:31.540Z"
};

export default buildInfo;
